import { render, staticRenderFns } from "./RecogSidebar.vue?vue&type=template&id=1b63b100&scoped=true&"
import script from "./RecogSidebar.vue?vue&type=script&lang=ts&"
export * from "./RecogSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./RecogSidebar.vue?vue&type=style&index=0&id=1b63b100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63b100",
  null
  
)

export default component.exports